function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from "react";
import LazyLoad from "react-lazy-load";
import { connect } from "react-redux";
import { HAS_ACCESS, KEY_ENTER, KEY_SPACE, ORDER_SUBSCRIPTIONS_ENABLED, ROUTE_ORDER_SUBSCRIPTIONS, ROUTE_SEARCH, SEARCH_TYPE_ACTIVE, TRANSITION_TIMEOUT } from "@config/constants";
import ShowCategories from "@common/components/show/ShowCategories";
import ShowImage from "@common/components/show/ShowImage";
import ShowLogo from "@common/components/show/ShowLogo";
import { getDateAndTimeWithLive, getDateAndTimeString, getDurationString } from "@common/services/helpers";
var Show = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Show, Component);
    var _super = _create_super(Show);
    function Show(props) {
        _class_call_check(this, Show);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "renderSeeSchedule", function() {
            var _this_props = _this.props, i18n = _this_props.i18n, shouldLinkBeColorful = _this_props.shouldLinkBeColorful, locked = _this_props.locked, logo = _this_props.logo;
            var hasAccess = !locked && (logo === null || logo === void 0 ? void 0 : logo.access) === HAS_ACCESS;
            return /*#__PURE__*/ _jsxs("p", {
                className: "see-schedule-wrapper".concat(shouldLinkBeColorful ? " colorful" : ""),
                onFocus: function() {
                    return _this.handleFocusChange(true);
                },
                onBlur: function() {
                    return _this.handleFocusChange(false);
                },
                children: [
                    hasAccess && /*#__PURE__*/ _jsx("span", {
                        className: "see-schedule-title",
                        children: i18n.common.seeSchedule
                    }),
                    hasAccess && /*#__PURE__*/ _jsx("span", {
                        className: "icon icon-keyboard-arrow-right"
                    })
                ]
            });
        });
        _this.state = {
            showTabIndex: "0",
            isFocused: false,
            shouldLinkBeColorful: false
        };
        _this.show = null;
        _this.goToSearch = _this.goToSearch.bind(_assert_this_initialized(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind(_assert_this_initialized(_this));
        _this.handleFocusChange = _this.handleFocusChange.bind(_assert_this_initialized(_this));
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_assert_this_initialized(_this));
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_assert_this_initialized(_this));
        _this.handleHeaderClick = _this.handleHeaderClick.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(Show, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.videoPlayerWrapper && this.props.videoPlayerWrapper.contains(this.show)) {
                    this.setState({
                        showTabIndex: "-1"
                    });
                }
            }
        },
        {
            /**
     * Navigate to search page with
     * query param set to the show's title
     */ key: "goToSearch",
            value: function goToSearch() {
                var _this_props = this.props, history = _this_props.history, show = _this_props.show, closePlayer = _this_props.closePlayer, videoPlayer = _this_props.videoPlayer, logo = _this_props.logo;
                if (logo && (logo === null || logo === void 0 ? void 0 : logo.access) !== HAS_ACCESS && ORDER_SUBSCRIPTIONS_ENABLED) {
                    this.props.history.push(ROUTE_ORDER_SUBSCRIPTIONS);
                } else {
                    var quotedTitle = '"'.concat(show.title, '"');
                    var query = "?query=".concat(encodeURIComponent(quotedTitle), "&type=").concat(SEARCH_TYPE_ACTIVE);
                    var prevQuery = history.location.search;
                    if (prevQuery === query) {
                        return;
                    }
                    history && history.push("".concat(ROUTE_SEARCH).concat(query));
                    if (videoPlayer.isOpen) {
                        closePlayer();
                    }
                }
            }
        },
        {
            /**
     * Changes the element's focus
     * @param isFocused {Boolean}
     */ key: "handleFocusChange",
            value: function handleFocusChange(isFocused) {
                if (isFocused !== this.state.isFocused) {
                    this.setState({
                        isFocused: isFocused
                    });
                }
            }
        },
        {
            /**
     * Triggers goToSearch method on enter or space keydown
     * @param event {Object}
     */ key: "handleKeyDown",
            value: function handleKeyDown(event) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    this.goToSearch(event);
                    event.stopPropagation();
                }
            }
        },
        {
            key: "handleMouseEnter",
            value: function handleMouseEnter() {
                this.setState({
                    shouldLinkBeColorful: true
                });
            }
        },
        {
            key: "handleMouseLeave",
            value: function handleMouseLeave() {
                this.setState({
                    shouldLinkBeColorful: false
                });
            }
        },
        {
            key: "handleHeaderClick",
            value: function handleHeaderClick() {
                var _this_props = this.props, history = _this_props.history, show = _this_props.show, locked = _this_props.locked, logo = _this_props.logo;
                var hasAccess = (logo === null || logo === void 0 ? void 0 : logo.access) === HAS_ACCESS;
                !locked && hasAccess && history.push("/channel/".concat(show.chanId), {
                    temporalUnlock: true
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _this = this;
                if (nextProps.isOpenEpgsList !== this.props.isOpenEpgsList) {
                    if (nextProps.isOpenEpgsList) {
                        this.setState({
                            showTabIndex: "0"
                        });
                        setTimeout(function() {
                            if (_this.show && _this.show.classList.contains("slick-current")) {
                                _this.show.focus();
                            }
                        }, TRANSITION_TIMEOUT);
                    } else {
                        this.setState({
                            showTabIndex: "-1"
                        });
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props_channel, _this_props, _show_persons_find, _show_persons, _show_persons_find1, _show_persons1, _show_actors;
                var _this_state = this.state, showTabIndex = _this_state.showTabIndex, isFocused = _this_state.isFocused;
                var _this_props1 = this.props, className = _this_props1.className, containerEvents = _this_props1.containerEvents, i18n = _this_props1.i18n, isInPlayer = _this_props1.isInPlayer, logo = _this_props1.logo, show = _this_props1.show, showLiveLabel = _this_props1.showLiveLabel, tabIndex = _this_props1.tabIndex, isCardWithoutHeader = _this_props1.isCardWithoutHeader, locked = _this_props1.locked, hasAccess = _this_props1.hasAccess, _this_props_shouldLazyLoad = _this_props1.shouldLazyLoad, shouldLazyLoad = _this_props_shouldLazyLoad === void 0 ? false : _this_props_shouldLazyLoad, index = _this_props1.index, length = _this_props1.length;
                var tabIndexDynamic = this.show && !this.show.classList.contains("slick-active") ? showTabIndex : "-1";
                var containerProps = _object_spread({}, containerEvents);
                var showTitleProps = {};
                if (containerEvents && ((logo === null || logo === void 0 ? void 0 : logo.access) === HAS_ACCESS || ORDER_SUBSCRIPTIONS_ENABLED)) {
                    containerProps.className = "pointer";
                    containerProps.tabIndex = isInPlayer ? tabIndexDynamic : "0";
                    containerProps.onFocus = function() {
                        return _this.handleFocusChange(true);
                    };
                    containerProps.onBlur = function() {
                        return _this.handleFocusChange(false);
                    };
                } else {
                    showTitleProps.onKeyDown = this.handleKeyDown;
                    showTitleProps.onClick = this.goToSearch;
                // showTitleProps.tabIndex = isInPlayer ? tabIndexDynamic : "0";
                }
                var cardClasses = className || "";
                cardClasses += " show show-bigger";
                cardClasses += isCardWithoutHeader ? " shorter" : "";
                var showImageComponent = /*#__PURE__*/ _jsx(ShowImage, _object_spread_props(_object_spread({}, this.props), {
                    hasLabel: false,
                    hasLogo: false,
                    mouseOverHandler: this.handleFocusChange,
                    showLiveLabel: false,
                    noImageEvents: !!containerEvents,
                    tabIndexDynamic: tabIndexDynamic,
                    "aria-hidden": true
                }));
                var showThumbnail = shouldLazyLoad ? /*#__PURE__*/ _jsx(LazyLoad, {
                    className: "show-thumbnail",
                    offset: 1000,
                    debounce: false,
                    "aria-hidden": true,
                    children: showImageComponent
                }) : showImageComponent;
                var showPointer = (logo === null || logo === void 0 ? void 0 : logo.access) === HAS_ACCESS && !locked;
                var _show_numeration_SeasonNumber, _this_props_channel_name;
                var ariaLabel = "Предаване ".concat(index + 1, " от ").concat(length, "... ").concat(show.title, "...\n        Сезон ").concat((_show_numeration_SeasonNumber = show.numeration.SeasonNumber) !== null && _show_numeration_SeasonNumber !== void 0 ? _show_numeration_SeasonNumber : "", ", Епизод ").concat(show.numeration.EpisodeNumber, "...\n         ").concat(show.major_category, " ").concat(show.minor_categories, "...\n         излъчван по ").concat((_this_props_channel_name = (_this_props = this.props) === null || _this_props === void 0 ? void 0 : (_this_props_channel = _this_props.channel) === null || _this_props_channel === void 0 ? void 0 : _this_props_channel.name) !== null && _this_props_channel_name !== void 0 ? _this_props_channel_name : "", " ").concat(getDateAndTimeString(show.start, show.stop, i18n.months, show.year), "...\n        ").concat(show.duration ? "Продължителност ".concat(show.duration, "...") : "", "\n        ").concat(show.agerating ? "Възрастово ограничение ".concat(show.agerating, "...") : "", "\n        ").concat((show === null || show === void 0 ? void 0 : (_show_persons = show.persons) === null || _show_persons === void 0 ? void 0 : (_show_persons_find = _show_persons.find(function(e) {
                    e.function === "Director";
                })) === null || _show_persons_find === void 0 ? void 0 : _show_persons_find.name) ? "Режисьор ".concat(show === null || show === void 0 ? void 0 : (_show_persons1 = show.persons) === null || _show_persons1 === void 0 ? void 0 : (_show_persons_find1 = _show_persons1.find(function(e) {
                    e.function === "Director";
                })) === null || _show_persons_find1 === void 0 ? void 0 : _show_persons_find1.name, "...") : "", "\n        ").concat((show === null || show === void 0 ? void 0 : (_show_actors = show.actors) === null || _show_actors === void 0 ? void 0 : _show_actors.length) > 0 ? "Актьори ".concat(show === null || show === void 0 ? void 0 : show.actors, "...") : "", "\n        ");
                return /*#__PURE__*/ _jsx("div", {
                    ref: function(node) {
                        return _this.show = node;
                    },
                    "aria-label": ariaLabel,
                    tabIndex: tabIndex,
                    className: cardClasses,
                    children: show ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            !isCardWithoutHeader && /*#__PURE__*/ _jsxs("div", {
                                className: "show-header ".concat(showPointer ? "pointer " : "", " ").concat(isFocused ? "focused" : "not-focused"),
                                onMouseEnter: this.handleMouseEnter,
                                onMouseLeave: this.handleMouseLeave,
                                onClick: this.handleHeaderClick,
                                children: [
                                    this.renderSeeSchedule(),
                                    /*#__PURE__*/ _jsx(ShowLogo, {
                                        logo: logo
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, containerProps), {
                                children: [
                                    showThumbnail,
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "show-info",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "date-time",
                                                "aria-hidden": true,
                                                dangerouslySetInnerHTML: getDateAndTimeWithLive(show.start, show.stop, i18n.months, showLiveLabel)
                                            }),
                                            /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                                                className: "show-title",
                                                "aria-hidden": true,
                                                "data-tip": "".concat(i18n.common.searchChannel, ": ").concat(show.title),
                                                "data-for": isInPlayer ? "player-slider-tooltip" : "show-slider-tooltip"
                                            }, showTitleProps), {
                                                children: show.title
                                            })),
                                            /*#__PURE__*/ _jsx(ShowCategories, {
                                                minorCategories: show["minor_categories"] || show.categories,
                                                majorCategory: show["major_category"]
                                            })
                                        ]
                                    })
                                ]
                            }))
                        ]
                    }) : null
                });
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
                // Returning `false` hugely improves the sliding experience
                // on mobile browsers. Before this fix the `render` method
                // was being called on every swipe. As long as this component
                // won't be updated dynamically this behaviour is OK.
                return nextState.showTabIndex !== this.state.showTabIndex || nextState.isFocused !== this.state.isFocused || nextState.shouldLinkBeColorful !== this.state.shouldLinkBeColorful || nextProps.currentWatchedEpg !== this.props.currentWatchedEpg || nextProps.logo !== this.props.logo || nextProps.thumbnail !== this.props.thumbnail;
            }
        }
    ]);
    return Show;
}(Component);
var mapStateToProps = function(param) {
    var videoPlayer = param.videoPlayer;
    return {
        videoPlayer: videoPlayer
    };
};
export default connect(mapStateToProps)(Show);
